import { Icon } from "@material-ui/core";
import React from "react";
import PrimaryTheme from "../Themes/Primary";
import Select from "./Select";

export default function MetricsCard(props: MetricsCardProps) {
  return (
    <React.Fragment>
      <div
        className="border-radius box-shadow overflow-hidden mb-3"
        style={{
          minHeight: 120,
          backgroundColor: props.background
            ? props.background
            : PrimaryTheme.white,
          width: "100%",
        }}
      >
        <div className="col-md-12 col-12  p-3">
          <div className="row m-0 justify-content-between align-items-center">
            <h6
              style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                fontSize: 14,
                textTransform: "uppercase",
              }}
            >
              {props.title}
            </h6>
            {props.handleActive && (
              <Select
                specialActive="Active Agent"
                list={["One", "Two", "Three"]}
                firstUL={props.id}
                id={props.id}
                onChange={props.onMenuChange}
              />
            )}
            {props.handlePOSMenu && (
              <select
                name="menu"
                className="bg-warning"
                id={props.id}
                onChange={props.onMenuChange}
                style={{
                  borderRadius: 4,
                  fontSize: 14,
                  padding: "3px 8px",
                }}
              >
                <option value="1">Total</option>
                <option value="2">Active</option>
                <option value="3">Inactive</option>
                <option value="4">Non-transacting</option>
                <option value="5">Unassigned</option>
              </select>
            )}

            {/* {props.handleEarningMenu && (
              <select
                name="menu"
                className="bg-warning"
                id={props.id}
                onChange={props.onMenuChange}
                style={{
                  borderRadius: 4,
                  fontSize: 14,
                  padding: "3px 8px",
                }}
              >
                <option value="Today">Today</option>
                <option value="Yesterday">Yesterday</option>
                <option value="Week">Week</option>
                <option value="Month">Month</option>
              </select>
            )} */}
            {props.handleTodayDropdown && (
              <select
                name="menu"
                className="bg-warning"
                id={props.id}
                onChange={props.onMenuChange}
                style={{
                  borderRadius: 4,
                  fontSize: 14,
                  padding: "3px 8px",
                }}
              >
                <option value="Today">Today</option>
                <option value="Yesterday">Yesterday</option>
                <option value="Week">Week</option>
                <option value="Month">Month</option>
              </select>
            )}
            {props.hasMenu && (
              <Select
                active="Day"
                list={["Day", "Week", "Month"]}
                firstUL={props.id}
                id={props.id}
                onChange={props.onMenuChange}
              />
            )}
            {props.hasFloatButton && (
              <button
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  border: "none",
                  fontSize: PrimaryTheme.fontSizes?.normal,
                  backgroundColor: PrimaryTheme.warn,
                  borderRadius: "6px",
                }}
                onClick={props.hasFloatButton}
              >
                Float
              </button>
            )}
          </div>
          <div className="row m-0 justify-content-between align-items-center">
            {props.value && !props.isLoading && (
              <h2
                className="m-0 pt-3 pb-3"
                style={{
                  color: props.valueColor,
                }}
              >
                {!props.isValue
                  ? props.value?.toLocaleString()
                  : props.value?.toLocaleString()}
              </h2>
            )}
            {props.value && props.isLoading && (
              <p
                className="m-0 pt-4 pb-3"
                style={{
                  color: props.valueColor,
                }}
              >
                {" "}
                <Icon className="rotate">cached</Icon>{" "}
              </p>
            )}
            {props.handleEarningMenu && (
              <button
                style={{                                                      
                  paddingLeft: "24px",
                  paddingRight: "24px",
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  border: "none",
                  fontSize: PrimaryTheme.fontSizes?.normal,
                  backgroundColor: PrimaryTheme.primary,
                  color: PrimaryTheme.white,
                  borderRadius: "56px",
                }}
                onClick={props.buttonClick}
              >
                Cashout
              </button>
            )}
            {props.handleFloatBtn && (
              <button
                style={{                                                      
                  paddingLeft: "24px",
                  paddingRight: "24px",
                  paddingTop: '12px',
                  paddingBottom: '12px',
                  border: "none",
                  fontSize: PrimaryTheme.fontSizes?.normal,
                  backgroundColor: PrimaryTheme.primary,
                  color: PrimaryTheme.white,
                  borderRadius: "56px",
                }}
                onClick={props.buttonClick}
              >
                Withdraw
              </button>
            )}

          </div>
          {/* {props.value && !props.isLoading && (
            <h2
              className="m-0 pt-3 pb-3"
              style={{
                color: props.valueColor,
              }}
            >
              {!props.isValue
                ? props.value?.toLocaleString()
                : props.value?.toLocaleString()}
            </h2>
          )}
          {props.value && props.isLoading && (
            <p
              className="m-0 pt-4 pb-3"
              style={{
                color: props.valueColor,
              }}
            >
              {" "}
              <Icon className="rotate">cached</Icon>{" "}
            </p>
          )} */}
        </div>

        {props.hasButton && (
          <div
            className="col-md-12 p-2"
            style={{
              background: props.buttonColor,
            }}
          >
            <button
              className="btn w-100"
              disabled={props.disabled}
              onClick={props.buttonClick}
              style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                color: PrimaryTheme.white,
              }}
            >
              {props.buttonTitle}
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

interface MetricsCardProps {
  id?: string;
  title?: string;
  value?: any;
  buttonTitle?: string;
  isValue?: boolean;
  hasMenu?: boolean;
  buttonColor?: string;
  valueColor?: string;
  hasButton?: boolean;
  background?: string;
  buttonClick?: any;
  onMenuChange?: any;
  isLoading?: boolean;
  disabled?: boolean;
  hasTopButton?: boolean;
  sendFloat?: any;
  hasFloatButton?: any;
  handleActive?: boolean;
  handlePOSMenu?: boolean;
  handleEarningMenu?: boolean;
  handleFloatBtn?: boolean;
  handleTodayDropdown?: boolean;
}
